import { render, staticRenderFns } from "./SyncService.vue?vue&type=template&id=4875a518&scoped=true&"
import script from "./SyncService.vue?vue&type=script&lang=js&"
export * from "./SyncService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4875a518",
  null
  
)

export default component.exports